import { HttpParams } from '@angular/common/http';
import { BaseFilterViewModel } from './base-filter-view-model';

export class ReviewDocumentFilterViewModel extends BaseFilterViewModel {
  public Type: ReviewDocFilterType = ReviewDocFilterType.ByReviewId;
  public ReviewId: number = 0;

  public getAsHttpParams(): HttpParams {
    let params = super.getAsHttpParams();
    params = params.append('filter.Type', encodeURIComponent(`${this.Type}`));
    params = params.append(
      'filter.ReviewId',
      encodeURIComponent(`${this.ReviewId}`)
    );
    return params;
  }
}

export enum ReviewDocFilterType {
  ByReviewId = 0x1,
}
